import api from './client';

export const coaApi = {
  list: () => api.get('/coa'),
};
